import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from 'sheets';
import localize from 'components/Localize/Localize';
import Modal from 'components/Modal/Modal';

import styles from './PayBrightModal.css';
import translations from './translations';

class PayBrightModal extends React.Component {
  render() {
    return (
      <Modal
        keyName="paybright"
        modalStyles={styles[`container`]}
      >
        <div>
          <div>
            <h1 className={styles[`heading`]}>
              <Icon
                className={styles[`casper-icon`]}
                name="logo"
              />
              <span className={styles[`title-plus`]}>
                +
              </span>
              <img
                alt={this.props.t.imageDescription}
                className={styles[`paybright-icon`]}
                src="/assets-spa/images/paybright.svg"
              />
            </h1>
            <h2 className={styles[`sub-heading`]}>
              {this.props.t.copy}
            </h2>
            <div className={styles[`callouts`]}>
              {this.props.t.callouts.map((callout)=>{
                return (
                  <div
                    className={styles[`callout`]}
                    key={callout.title}
                  >
                    <img
                      alt=""
                      className={styles[`callout-icon`]}
                      src={callout.icon}
                    />
                    <div className={styles[`callout-container`]}>
                      <span className={styles[`callout-title`]}>
                        {callout.title}
                      </span>
                      <p>
                        {callout.copy}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className={styles[`copy`]}>
              {this.props.t.subtitle1}
              <img
                alt={this.props.t.imageDescription}
                className={styles[`paybright-icon`]}
                src="/assets-spa/images/paybright.svg"
              />
              {this.props.t.subtitle2}
            </div>
          </div>
          <div className={styles[`footer`]}>
            {this.props.t.disclaimer}
          </div>
        </div>
      </Modal>
    );
  }
}

PayBrightModal.propTypes = {
  t: PropTypes.shape({
    callouts: PropTypes.array.isRequired,
    copy: PropTypes.string.isRequired,
    disclaimer: PropTypes.string.isRequired,
    imageDescription: PropTypes.string.isRequired,
    subtitle1: PropTypes.string.isRequired,
    subtitle2: PropTypes.string.isRequired,
  }).isRequired,
};

export default localize(PayBrightModal, translations);
